import { createHead } from "@unhead/vue";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import * as Sentry from "@sentry/vue";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import Message from "primevue/message";
import ProgressSpinner from "primevue/progressspinner";
import { createApp } from "vue";
import { createPinia } from "pinia";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";

import App from "./App.vue";
import router from "./router";

import "@/assets/main.css";

const app = createApp(App);
const pinia = createPinia();

if (import.meta.env.MODE === "production") {
  Sentry.init({
    app,
    dsn: "https://2ae2728bd39c4b30a2e911b0265b2eb4@errors2.danemco.net/70",
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.5,
  });

  pinia.use(Sentry.createSentryPiniaPlugin());
}

app.component("Button", Button);
app.component("Message", Message);
app.component("ProgressSpinner", ProgressSpinner);

app.use(pinia);
app.use(router);
app.use(createHead());

const KellyPartners = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
    blue: {
      50: "#b3ebff",
      100: "#66d6ff",
      200: "#00b6f8",
      300: "#0090d7",
      400: "#0071b7",
      500: "#005e9e",
      600: "#00538a",
      700: "#004d80",
      800: "#0a3d66",
      900: "#093252",
      950: "#08253c",
    },
  },
});

app.use(PrimeVue, {
  theme: {
    preset: KellyPartners,
    options: {
      darkModeSelector: "",
    },
  },
});
app.use(ToastService);
app.component("Toast", Toast);

app.mount("#app");
